<template>
  <div class="tooltip-container" @mouseenter="show = true" @mouseleave="show = false">
    <div class="tooltip-icon">?
          <div class="tooltip-content" v-if="show">
            <div v-html="text"></div>
            <a v-if="link" :href="link" target="_blank" >{{ linkText }}</a>
          </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoTooltip",
  props: {
    text: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: null,
    },
    linkText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style scoped>
.tooltip-container {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.tooltip-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: var(--col_2);
  color: white;
  text-align: center;
  border-radius: 50%;
  font-weight: bold;
  line-height: 18px;
  font-size: 14px;
}

.tooltip-content {
  position: absolute;
  text-align: left;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  color: var(--col_1);
  padding: 6px 10px;
  border-radius: 4px;
  font-weight: 300;
  //white-space: nowrap;
  font-size: 13px;
  z-index: 100;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--col_1);
  max-width: min(90vw, 400px);
  min-width: min(90vw, 360px);

}
.tooltip-content em{
  color: var(--col_2);
  font-weight: 600;
  font-style: normal ;

}
a{
  color: white;
}
</style>
<style>
.tooltip-content em{
  color: var(--col_2);
  font-weight: 600;
  width: 100%;
  font-style: normal;

}
.tooltip-content a{
  color: var(--col_1);
}
</style>
